import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Directory } from '../directory';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.css']
})
export class ContextMenuComponent {
  @Input() contextMenuPosition: { x: number; y: number };
  @Input() contextMenuDirectory: Directory;

  @Output()
  onClickDelete = new EventEmitter<Directory>();
  @Output()
  onClickAdd = new EventEmitter<Directory>();
  @Output()
  onClickRename=new EventEmitter<Directory>();
  @Output()
  onMouseLeave = new EventEmitter<boolean>();

  @Input()
  allDirectories: Directory[] = [];

  private mouseLeaveTimer: any;
  add(directory: Directory) {
    console.log('Abriendo modal para agregar directorio', directory);
    this.onClickAdd.emit(directory);
  }

  del(directory: Directory) {
    console.log('Abriendo modal para eliminar directorio', directory);
    this.onClickDelete.emit(directory);
  }
  rename(directory: Directory) {
    console.log('Abriendo modal para renombrar directorio', directory);
    this.onClickRename.emit(directory);
  }
  mouseLeave() {
    console.log("Perdió el foco");
    // Utilizar un temporizador para emitir el evento después de un pequeño retraso
    this.mouseLeaveTimer = setTimeout(() => {
      this.onMouseLeave.emit(true);
    }, 200); // Ajusta el tiempo según tus preferencias
  }
  mouseEnter() {
    console.log("Entró al elemento");
    // Limpiar el temporizador si el mouse vuelve al menú antes de que expire el temporizador
    if (this.mouseLeaveTimer) {
      clearTimeout(this.mouseLeaveTimer);
      this.mouseLeaveTimer = null;
    }
  }
  getRootDirectory(directory: Directory, children: number = 0): any {
    var ini: number = children;
    if (directory.directory_id && directory.directory_id > 0) {
      const parentDirectory = this.allDirectories.find(d => directory.directory_id == d.id);
      if (parentDirectory) {
        ini++;
        return this.getRootDirectory(parentDirectory, ini);
      }
    }
    return { "root": directory, "count": ini };
  }
  allowSubdirectory(subdirectory: Directory): boolean {
    var allow: boolean = false;
    const parent = this.getRootDirectory(subdirectory);
    if (parent?.count < 2) {
      allow = true;
    }
    return allow;
  }
}
